export default "__VITE_ASSET__CnTsoLdw__"